<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Cartera del cliente {{ cliente.nombre_comercial }}</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="consultar" type="button" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button @click="exportarPDF" class="btn-danger">
            <i class="fa fa-file-pdf-o"></i><span>Exportar PDF</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Filtros de consulta</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select
                  name="tipo_fecha"
                  id="tipo_fecha"
                  @change="changeTipoFecha"
                  v-model="form.tipo_fecha"
                >
                  <option value="F">A la fecha</option>
                  <option value="H">Hoy</option>
                  <option value="A">Ayer</option>
                  <option value="P">Personalizado</option>
                </select>
                <label for="tipo_fecha">Tipo de fecha</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field" v-show="form.tipo_fecha === 'P'">
              <div class="datepicker-field datepicker-field--stretch">
                <VueCtkDateTimePicker
                  id="desde"
                  v-model="form.desde"
                  locale="es"
                  no-label
                  only-date
                  auto-close
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Desde</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field" v-show="form.tipo_fecha === 'P'">
              <div class="datepicker-field datepicker-field--stretch">
                <VueCtkDateTimePicker
                  id="hasta"
                  v-model="form.hasta"
                  locale="es"
                  no-label
                  only-date
                  auto-close
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Hasta</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-2">
      <div class="card__content">
        <vs-table
          search
          max-items="20"
          pagination
          :data="mostrarSinSaldos(registros)"
        >
          <template slot="header">
            <h5>Registros:</h5>
          </template>
          <template slot="thead">
            <vs-th># Doc</vs-th>
            <vs-th>Fecha</vs-th>
            <vs-th>Vencimiento</vs-th>
            <vs-th>Mora</vs-th>
            <vs-th>Concepto</vs-th>
            <vs-th>Valor</vs-th>
            <vs-th>Retención</vs-th>
            <vs-th>Cobrado</vs-th>
            <vs-th>Saldo</vs-th>
            <vs-th>Forma de pago</vs-th>
            <vs-th>Vendedor</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td
                >{{ data[indextr].cod_tipo_doc }}-{{
                  data[indextr].num_doc
                }}</vs-td
              >
              <vs-td>{{ data[indextr].fecha_doc }}</vs-td>
              <vs-td>{{ data[indextr].fecha_vencto }}</vs-td>
              <vs-td>{{ calcularMora(data[indextr]) }}</vs-td>
              <vs-td>{{ data[indextr].concepto }}</vs-td>
              <vs-td>{{ moneyFormat(data[indextr].total) }}</vs-td>
              <vs-td>{{ moneyFormat(data[indextr].retenciones) }}</vs-td>
              <vs-td>{{ moneyFormat(data[indextr].valor_cobrado) }}</vs-td>
              <vs-td>{{ moneyFormat(calcularSaldo(data[indextr])) }}</vs-td>
              <vs-td>{{ data[indextr].des_forma_pago }}</vs-td>
              <vs-td>{{ data[indextr].des_vendedor }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="table-responsive">
          <table>
            <thead>
              <tr>
                <th>Valor total</th>
                <th>Retenciones totales</th>
                <th>Total cobrado</th>
                <th>Total de saldo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{ moneyFormat(totalValor) }}
                </td>
                <td>
                  {{ moneyFormat(totalRetenciones) }}
                </td>
                <td>
                  {{ moneyFormat(totalCobrado) }}
                </td>
                <td>
                  {{ moneyFormat(totalSaldo) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    totalValor: function () {
      let registros = this.mostrarSinSaldos(this.registros);
      let totalValor = 0;
      for (let i = 0; i < registros.length; i++) {
        let valor = parseFloat(registros[i].total);
        totalValor = round(totalValor + valor, 2);
      }
      return totalValor;
    },
    totalRetenciones: function () {
      let registros = this.mostrarSinSaldos(this.registros);
      let totalRetenciones = 0;
      for (let i = 0; i < registros.length; i++) {
        let valor = parseFloat(registros[i].retenciones);
        totalRetenciones = round(totalRetenciones + valor, 2);
      }
      return totalRetenciones;
    },
    totalCobrado: function () {
      let registros = this.mostrarSinSaldos(this.registros);
      let totalCobrado = 0;
      for (let i = 0; i < registros.length; i++) {
        let valor = parseFloat(registros[i].valor_cobrado);
        totalCobrado = round(totalCobrado + valor, 2);
      }
      return totalCobrado;
    },
    totalSaldo: function () {
      let totalSaldo = 0;
      totalSaldo = this.totalValor - this.totalRetenciones - this.totalCobrado;
      return round(totalSaldo, 2);
    },
  },
  props: {
    urlPdf: {
      type: String,
      required: false,
      default: "",
    },
    cliente: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      moneyFormat: moneyFormat,
      form: {
        tipo_fecha: "F",
        desde: "",
        hasta: "",
        sucursal_id: 9,
        cliente_id: this.cliente.cliente_id,
        vendedor_id: "T",
        cliente_name: this.cliente.nombre_comercial,
        empresa_id: 1,
      },
      registros: [],
    };
  },
  mounted() {
    this.changeTipoFecha();
  },
  methods: {
    calcularMora: function (registro) {
      if (registro.fecha_vencto != null && registro.fecha_vencto != "") {
        let fechaVencimiento = moment(
          new Date(registro.fecha_vencto + " 00:00:00")
        );
        let now = moment(new Date(moment().format("YYYY-MM-DD")));
        return parseInt(moment.duration(fechaVencimiento.diff(now)).asDays());
      } else return "";
    },
    mostrarSinSaldos: function (datos) {
      let saldos = [];
      for (let i = 0; i < datos.length; i++) {
        if (this.calcularSaldo(datos[i]) > 0) saldos.push(datos[i]);
      }
      return saldos;
    },
    calcularSaldo: function (registro) {
      let total = parseFloat(registro.total);
      if (isNaN(total)) total = 0;
      let valorCobrado = parseFloat(registro.valor_cobrado);
      if (isNaN(valorCobrado)) valorCobrado = 0;
      let retenciones = parseFloat(registro.retenciones);
      if (isNaN(retenciones)) retenciones = 0;
      return round(total - retenciones - valorCobrado);
    },
    consultar: function () {
      axios
        .get(url + "/cartera", {
          params: this.form,
        })
        .then(({ data }) => {
          this.registros = data;
        })
        .catch(() => {
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    exportarPDF: function () {
      let queryString = this.serialize(this.form);
      let urlApi = this.urlPdf + queryString;
      window.open(urlApi, "_blank");
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            if (val instanceof Date) val = val.toLocaleDateString("en");
            else if (val === undefined || val === null) val = "";
            a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    changeTipoFecha: function () {
      if (this.form.tipo_fecha === "H") {
        this.form.desde = moment().format("YYYY-MM-DD");
        this.form.hasta = moment().format("YYYY-MM-DD");
      } else if (this.form.tipo_fecha === "A") {
        this.form.desde = moment().add(-1, "days").format("YYYY-MM-DD");
        this.form.hasta = moment().add(-1, "days").format("YYYY-MM-DD");
      } else if (this.form.tipo_fecha === "P") {
        this.form.desde = moment().format("YYYY-MM-DD");
        this.form.hasta = moment().format("YYYY-MM-DD");
      } else if (this.form.tipo_fecha === "F") {
        this.form.desde = moment(new Date("2000-01-01")).format("YYYY-MM-DD");
        this.form.hasta = moment().format("YYYY-MM-DD");
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/Cartera.vue